import { useEffect, useState } from 'react';

export function useScrollPosition({ targetRef, shouldRegister = true } = {}) {
  const [scrollPosition, setScrollPosition] = useState(0);
  const scrollContainer =
    targetRef?.current || document.getElementById('page-container');

  const setScroll = (scrollY) => {
    if (scrollContainer) {
      scrollContainer.scrollTop = 0;
      setScrollPosition(scrollY);
    }
  };

  useEffect(() => {
    if (!shouldRegister) {
      return;
    }

    const updateScrollPosition = (event) => {
      setScrollPosition(event.target.scrollTop);
    };

    // اگر از پسیو ساپورت میکنه مرورگر پس اضافه میشه
    const supportsPassive = 'addEventListener' in document;
    const options = supportsPassive ? { passive: true } : false;

    if (scrollContainer) {
      scrollContainer.addEventListener('scroll', updateScrollPosition, options);
    }
    return () => {
      if (scrollContainer)
        scrollContainer.removeEventListener(
          'scroll',
          updateScrollPosition,
          options
        );
    };
  }, [scrollContainer, shouldRegister]);

  return { scrollPosition, setScroll };
}
